import helpers from 'helpers'
import constants from 'constants/index'
import { isEmpty } from 'lodash'

const formatJuridicParamsToApi = (params) => {
  if (!params) return {}

  let formattedParams = {
    name: params.name,
    companyName: params.companyName,
    description: params.description,
    cnpj: params.document
      ? helpers.formatters.regex.onlyNumbersAndLetters(params.document)
      : null,
    cpf: null,
    siteUrl: params.siteUrl || null,
    statusId: params.statusId,
    phone: helpers.formatters.regex.onlyNumbers(params.phone),
    stateRegistration: helpers.formatters.regex.onlyNumbers(
      params.stateRegistration,
    ),
    municipalRegistration: helpers.formatters.regex.onlyNumbers(
      params.municipalRegistration,
    ),
    email: params.email,
    kind: constants.companies.KINDS.COMPANY,
    groupId: helpers.formatters.getIdFromObject(params.groupId),
    subgroupId: helpers.formatters.getIdFromObject(params.subgroupId),
    segmentId: helpers.formatters.getIdFromObject(params.segmentId),
    companySizeId: helpers.formatters.getIdFromObject(params.companySizeId),
    companyTemplateId: helpers.formatters.getIdFromObject(
      params.companyTemplateId,
    ),
    blockUpdate: params.blockUpdate,
    provideServiceLegalFramework: params.provideServiceLegalFramework,
    acceptProcessFragility: params.acceptProcessFragility,
    notifyDataProcessChanges: params.notifyDataProcessChanges,
    notifyResponsibleDataProcessChanges:
      params.notifyResponsibleDataProcessChanges,
    anpdTicketChannel: params.anpdTicketChannel ?? true,
    segcoopIntegration: params.segcoopIntegration,
    beneficiarySebrae: params.beneficiarySebrae,
    address: {
      street: params.street,
      number: params.number,
      neighborhood: params.neighborhood,
      complement: params.complement || null,
      postalCode: helpers.formatters.regex.onlyNumbers(params.postalCode),
      city: params.city,
      country: params.country,
      state: params.state,
    },
    responsableUser: {
      id: helpers.formatters.getIdFromObject(params.responsibleUserId),
      name: params.responsibleName || null,
      email: params.responsibleEmail || null,
      phone: helpers.formatters.regex.onlyNumbers(params.responsiblePhone),
      cpf: helpers.formatters.regex.onlyNumbers(params.responsibleCpf) || null,
    },
    economicActivities: [
      {
        mainActivity: true,
        economicActivityId: helpers.formatters.getIdFromObject(
          params.economicActivityId,
        ),
      },
    ],
  }

  if (isEmpty(formattedParams.address.street)) {
    delete formattedParams.address
  }

  return formattedParams
}

export default formatJuridicParamsToApi
